import { render, staticRenderFns } from "./PdCreate.vue?vue&type=template&id=b42ec75c&scoped=true&"
import script from "./PdCreate.vue?vue&type=script&lang=ts&"
export * from "./PdCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42ec75c",
  null
  
)

export default component.exports